import { useParams } from 'react-router-dom';
import { VoucherProvider } from '../../context/VoucherProdiver';
import { CreationSuccess } from '../../components/CreationSuccess';

const SuccessPage = () => {
  const { id } = useParams();

  if (!id) return null;

  return (
    <VoucherProvider id={id}>
      <CreationSuccess />
    </VoucherProvider>
  );
};

export default SuccessPage;
